module.exports = __webpack_public_path__ + "img/icon4.b4220c9e.png";